/**
 * @file SkinPage.jsx
 * @description Provides platform-wide page layout and styling
 *
 * @section Responsibilities
 * - Manage page layout
 * - Handle theme application
 * - Process style updates
 * - Manage layout state
 * - Handle responsive design
 * - Provide consistent styling
 *
 * @section Dependencies
 * - ThemeService: Theme management
 * - StyleService: Style handling
 * - LayoutService: Layout management
 * - ResponsiveService: Responsive design
 *
 * @section Integration Points
 * - Theme System: Theme application
 * - Style System: Style management
 * - Layout System: Page layout
 * - Responsive System: Responsive design
 *
 * @section State Management
 * - layoutState: Layout status
 * - themeState: Theme status
 * - styleState: Style status
 * - responsiveState: Responsive status
 *
 * @section Events
 * - onLayoutChange: Layout updates
 * - onThemeChange: Theme updates
 * - onStyleUpdate: Style changes
 * - onResponsive: Responsive updates
 *
 * @section Props
 * @prop {Object} layoutConfig - Layout configuration
 * @prop {Object} themeConfig - Theme configuration
 * @prop {Boolean} responsive - Controls responsiveness
 * @prop {Function} onLayout - Layout callback
 */

import axios from "axios";
import "./../../assets/fonts.css";
import "./../../styles/global.css";
import "./../../styles/dashboard.css";
import "./../../styles/my-clients.css";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import Sidebar from "../../components/dashboard/Sidebar";
import Navbar from "../../components/dashboard/Navbar";
import { useSearchParams } from "react-router-dom";
import { DefRoutes } from "../../App";
import { getSessionObject } from "../../utils/sessionUtils";

const SkinPage = ({ children }) => {
  const userRole = getSessionObject().role;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const modules = DefRoutes.filter(
    (r) => typeof r.icon === "string" && r.allowedRoles.includes(userRole)
  );
  // console.log(modules);
  const logout = () => {
    axios.delete(`${process.env.REACT_APP_BASE_URL}/user/auth`).then((res) => {
      navigate("/login");
    });
  };

  useEffect(() => {
    // if (searchParams.get("code")) {
    //   authenticate(searchParams.get("code"), navigate);
    //   setTimeout(() => {
    //     searchParams.delete("code");
    //     setSearchParams(searchParams);
    //   }, 1000);
    // } else {
    //   validateRoute();
    // }
  }, []);

  return (
    <div className="admin">
      <div className="background">
        <div className="container">
          <Navbar></Navbar>
          <div className="admin-content">
            <div className="column column-sidebar">
              <Sidebar data={modules} role={userRole}></Sidebar>
            </div>
            <div className="column column-content">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkinPage;
